import request from '../../../../setup/axios/request'

export const getPaymentBacklogs = (data: any) => {
  return request({
    url: '/api/v1/payment/get-payment-backlogs',
    method: 'post',
    data: data,
  })
}

export const createSellingPayment = (data: any) => {
  return request({
    url: '/api/v1/payment/selling-payment-create',
    method: 'post',
    data: data,
  })
}

export const getPaymentDetail = (id: any) => {
  return request({
    url: '/api/v1/payment/get-payment-detail?Id=' + id,
    method: 'get',
  })
}

export const sellingPaymentDelete = (id: any) => {
  return request({
    url: '/api/v1/payment/selling-payment-delete?Id=' + id,
    method: 'delete'
  })
}

export const getListPayment = (data: any) => {
  return request({
    url: '/api/v1/payment/get-list-payment',
    method: 'post',
    data: data,
  })
}

export const getListCommission = (data: any) => {
  return request({
    url: '/api/v1/payment/get-list-commission',
    method: 'post',
    data: data,
  })
}

export const getCommissionBacklogs = (data: any) => {
  return request({
    url: '/api/v1/payment/get-commission-backlogs',
    method: 'post',
    data: data,
  })
}

export const createSellingCommission = (data: any) => {
  return request({
    url: '/api/v1/payment/create-selling-commission',
    method: 'post',
    data: data,
  })
}

export const getCommissionDetail = (id: any) => {
  return request({
    url: '/api/v1/payment/get-commission-detail?Id=' + id,
    method: 'get',
  })
}

export const sellingCommissionDelete = (id: any) => {
  return request({
    url: '/api/v1/payment/delete-selling-commission?Id=' + id,
    method: 'delete'
  })
}

export const getListCancelContract = (data: any) => {
  return request({
    url: '/api/v1/ContractCancel/get-list-cancel-contract',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(data),
    },
  })
}

export const cancelContract = (data: any) => {
  return request({
    url: '/api/v1/ContractCancel/cancel-contract',
    method: 'post',
    data: data,
  })
}

export const deleteCancelContract = (data: any) => {
  return request({
    url: '/api/v1/ContractCancel/delete-cancel-contract',
    method: 'post',
    data: data,
  })
}

export const getCancelContractById = (id: any) => {
  return request({
    url: '/api/v1/ContractCancel/cancel-contract-byid?Id=' + id,
    method: 'get'
  })
}

export const approveContractCancel = (data: any) => {
  return request({
    url: '/api/v1/SubmitForApproval/approve-contract-cancel',
    method: 'post',
    data: data
  })
}
